export default "__VITE_ASSET__LystcOj2__"